export default {
  EMAIL_SUBSCRIPTION_LOAD: 'EMAIL_SUBSCRIPTION_LOAD',
  EMAIL_SUBSCRIPTION_ERROR: 'EMAIL_SUBSCRIPTION_ERROR',
};
